// src/components/admin/performance/AdminPerformanceManagement.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FileText, Users, CheckCircle, TrendingUp } from 'lucide-react';
import TemplateManagement from './TemplateManagement';
import PerformanceReviewsTable from './PerformanceReviewsTable';
import PendingReviewsTable from './PendingReviewsTable';
import CompanyPerformanceAnalytics from './CompanyPerformanceAnalytics';

const AdminPerformanceManagement = () => {
    const [activeTab, setActiveTab] = useState('pending'); // 'pending', 'reviews', 'templates', or 'analytics'
    const tabLocation = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(tabLocation.search);
        const tab = params.get('tab');
        if (tab) setActiveTab(tab);
    }, [tabLocation.search]);

    const tabs = [
        { id: 'pending', label: 'Pending Reviews', icon: CheckCircle },
        { id: 'reviews', label: 'Confirmed Reviews', icon: Users },
        { id: 'templates', label: 'Review Templates', icon: FileText },
        { id: 'analytics', label: 'Performance Analytics', icon: TrendingUp }
    ];

    return (
        <div className="space-y-6">
            {/* Header */}
            <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Performance Management</h1>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    Manage performance reviews and templates across your organization
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="tour-performance-tabs -mb-px flex space-x-8">
                    {tabs.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`
                                    group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
                                    ${isActive
                                        ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                                    }
                                `}
                            >
                                <Icon className={`mr-2 h-5 w-5 ${isActive ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 group-hover:text-gray-500'}`} />
                                {tab.label}
                            </button>
                        );
                    })}
                </nav>
            </div>

            {/* Tab Content */}
            <div className="mt-6">
                {activeTab === 'pending' && <PendingReviewsTable />}
                {activeTab === 'reviews' && <PerformanceReviewsTable />}
                {activeTab === 'templates' && <TemplateManagement />}
                {activeTab === 'analytics' && <CompanyPerformanceAnalytics />}
            </div>
        </div>
    );
};

export default AdminPerformanceManagement;
